import React, { useEffect, useState } from 'react'
import DashboardLayout from '../../../components/layouts/dashboard'
import UnauthorizedPage from '../../errors/unauthorized'
import { useSelector } from 'react-redux'
import PlaceHolderImageSVG from '../../../assets/svg/hr/placeholder-img.svg'
import { useParams } from 'react-router-dom'
import {
  useAddAnnouncementComment,
  useDeleteAnnouncementComment,
  useGetSingleAnnouncement,
} from '../../../redux/employees/hook/announcement'
import LoadingBar from '../../../components/loader-bar'
import {
  formatDateInWords,
  formatNewDateInWords,
} from '../../../utils/functions'
import ButtonSVG from '../../../assets/svg/hr/send-button.svg'
import DoYouWantToModal from '../../../components/modal/do-you-want-to'
import Delete from '../../../assets/svg/delete.svg'

const ViewAnnouncement = () => {
  const [unauthorized, setUnauthorized] = useState(false)
  const { user } = useSelector((state) => state.userSlice)
  const { id } = useParams()

  const {
    data: announcement,
    isLoading,
    refetch,
  } = useGetSingleAnnouncement(id)
  const [comment, setComment] = useState(null)
  useEffect(() => {
    if (user) {
      if (user.permissions.company_permission.role !== 'Owner') {
        if (user.permissions.company_permission.promotion_read !== 1) {
          setUnauthorized(true)
        }
      }
    }
  }, [user])
  const { mutateAsync: addComment, isLoading: commentLoading } =
    useAddAnnouncementComment()
  const { mutateAsync: deleteComment, isLoading: deleteLoading } =
    useDeleteAnnouncementComment()
  const [commentId, setCommentId] = useState(null)
  const [showDoYouWant, setShowDoYouWant] = useState(false)

  const handleComment = async () => {
    if (!comment?.trim()) {
      return
    }
    try {
      await addComment({
        id: announcement?.id,
        data: { comment: comment },
      }).then(() => {
        refetch()
        setComment('')
      })
    } catch (error) {}
  }

  return (
    <DashboardLayout title='Announcements'>
      {showDoYouWant && (
        <DoYouWantToModal
          isOpen={showDoYouWant}
          closeModal={() => setShowDoYouWant(false)}
          id={commentId}
          type='delete'
          title='Are you sure you want to delete?'
          subtitle={'Once deleted comment cannot be retrived'}
          buttonText='DELETE'
          loading={deleteLoading}
          btnFunction={async (id) => {
            await deleteComment(id)
            setShowDoYouWant(false)
          }}
        />
      )}
      {unauthorized ? (
        <UnauthorizedPage />
      ) : (
        <>
          {isLoading ? (
            <div className='w-full items-center justify-center h-[500px]'>
              <LoadingBar loading={isLoading} />
            </div>
          ) : (
            <div className='flex md:flex-row flex-col gap-5 items-start w-full bg-white p-3 rounded'>
              <section className='flex flex-col gap-2 w-full border-none md:border-r md:border-r-gray-200'>
                <p>
                  By{' '}
                  {announcement.announcer?.first_name &&
                  announcement.announcer?.last_name
                    ? `${announcement.announcer.first_name} ${announcement.announcer.last_name}`
                    : user?.company?.company_name}{' '}
                  | {formatNewDateInWords(announcement?.publish_date)}{' '}
                </p>
                <p className='text-base font-semibold'>{announcement?.title}</p>
                <img
                  src={announcement.attachment ?? PlaceHolderImageSVG}
                  alt='centelHR'
                  className='max-w-[500px] max-h-[300px] object-cover'
                />
                <p className='text-base max-w-[700px]'>
                  {announcement?.content}
                </p>
                <div className='flex flex-col items-start gap-2'>
                  <p className='text-base font-semibold'>Reactions</p>
                  <div className='flex items-center gap-3 border rounded p-2'>
                    <div className='flex flex-col gap-1 items-center'>
                      <span className='cursor-pointer'> 👍</span>
                      <span>
                        {announcement?.reaction_counts?.thumbs_up ?? 0}
                      </span>
                    </div>
                    <div className='flex flex-col gap-1 items-center'>
                      <span className='cursor-pointer'> 👎</span>
                      <span>
                        {announcement?.reaction_counts?.thumbs_down ?? 0}
                      </span>
                    </div>
                  </div>
                </div>
              </section>
              <section className='flex flex-col w-full items-start'>
                <div className='flex items-center gap-1 mb-3'>
                  <h1 className='text-sm font-medium'>Comments </h1>

                  <span className='text-white text-xs bg-error h-5 w-5 flex items-center justify-center p-2 rounded-full'>
                    {announcement?.comments_count}
                  </span>
                </div>

                <main className='flex flex-col items-start gap-2 w-full'>
                  {announcement?.comments?.length > 0 ? (
                    <section className='h-[400px] w-full overflow-y-auto'>
                      {announcement?.comments?.map((comment, index) => (
                        <section
                          key={index}
                          className='flex justify-between items-center border-y-gray-200 p-2 w-full border-y'
                        >
                          <main className='flex flex-col gap-1 w-full '>
                            <h1 className='text-sm max-w-[500px] font-medium'>
                              {comment.comment}
                            </h1>
                            <p className='text-sm  text-gray-600'>
                              {comment.profile?.first_name &&
                              comment.profile?.last_name
                                ? `${comment.profile.first_name} ${comment.profile.last_name}`
                                : user?.company?.company_name}{' '}
                              | {formatDateInWords(comment?.created)}
                            </p>
                          </main>
                          <button
                            onClick={() => {
                              setShowDoYouWant(true)
                              setCommentId(comment?.id)
                            }}
                            disabled={deleteLoading}
                          >
                            <img src={Delete} alt='Delete Goal' />
                          </button>
                        </section>
                      ))}
                    </section>
                  ) : (
                    <p className='text-sm flex text-left items-center w-full h-[400px] font-bold text-[18px] text-black'>
                      No comments yet
                    </p>
                  )}
                </main>
                {announcement?.is_publish === 1 && (
                  <section className='my-3 w-full'>
                    <p className='text-sm text-black font-semibold'>
                      Add Comment
                    </p>
                    <div className='flex w-full items-center rounded-md px-2 my-2 border h-11'>
                      <input
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        placeholder='Add a comment'
                        type='text'
                        className='outline-none bg-transparent border-none w-full text-sm font-medium text-black'
                      />
                      <button
                        onClick={handleComment}
                        disabled={commentLoading || !comment?.trim()}
                        type='submit'
                        className='bg-hr-primary-1 cursor-pointer rounded-full p-2'
                      >
                        <img src={ButtonSVG} alt='CentelHR' />
                      </button>
                    </div>
                  </section>
                )}
              </section>
            </div>
          )}
        </>
      )}
    </DashboardLayout>
  )
}

export default ViewAnnouncement
